import { MatrixClient } from 'matrix-js-sdk/src/matrix';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useSoundMutedRoomIds from 'hooks/useSoundMutedRoomIds/useSoundMutedRoomIds';
import useSoundNotifications from 'hooks/useSoundNotifications/useSoundNotifications';
import useSoundSettings from 'hooks/useSoundSettings/useSoundSettings';
import useTotalUnreadCount from 'hooks/useTotalUnreadCount/useTotalUnreadCount';
import useUnreadTitleBadge from 'hooks/useUnreadTitleBadge/useUnreadTitleBadge';

const SoundNotificationsFeeder = () => {
  const { matrixClient } = useMatrixContext({ requireDefinedMatrixClient: false });
  if (!matrixClient) return null;
  return <MountedSoundNotificationsFeeder matrixClient={matrixClient} />;
};

interface MountedSoundNotificationsFeederProps {
  matrixClient: MatrixClient;
}

const MountedSoundNotificationsFeeder = ({ matrixClient }: MountedSoundNotificationsFeederProps) => {
  const { isMuted } = useSoundSettings();
  const mutedRoomIds = useSoundMutedRoomIds(matrixClient);
  useSoundNotifications({ isMuted, mutedRoomIds });

  const unreadCount = useTotalUnreadCount({ soundMutedRoomIds: mutedRoomIds });
  useUnreadTitleBadge(unreadCount);

  return null;
};

export default SoundNotificationsFeeder;
